import React, { useState, useEffect } from "react";
import { motion, useAnimation, AnimatePresence } from "framer-motion";

const Answer = ({ data, onClick }) => {
  const { image, answer, bgColor, tColor } = data;

  return (
    <div>
      <div
        className={"rounded-[12px] overflow-hidden my-5 cursor-pointer"}
        onClick={onClick}
      >
        <div
          className="w-full aspect-w-16 aspect-h-8 bg-cover bg-center"
          style={{
            backgroundImage: `url(${image})`,
          }}
        />
        <div style={{ backgroundColor: bgColor }}>
          <h3
            className={`p-3 uppercase font-headline text-l font-regular`}
            style={{ color: tColor }}
          >
            {answer}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Answer;
